/**
 * Handles navigation history and optionally opens a new window.
 * 
 * @param history - The history object used for navigation- ALWAYS  pass this in.
 * @param e - The event or URL string that triggered the navigation, pass in an URL when not using an anchor tag
 * @param newWindow - Optional flag to open the link in a new window, pass in e.ctrlKey when not using an anchor tag
 * 
 * ! AGAIN, WHEN PASSING IN AN URL FOR THE EVENT (e), PASS IN E.CTRLKEY
 *
 * If `e` is a string, it is treated as a URL. If `newWindow` is true, 
 * opens the URL in a new tab. Otherwise, uses the history object to 
 * navigate. If `e` is an event, it prevents the default navigation 
 * behavior unless the Control key is pressed. If `newWindow` is true, 
 * opens the event's target URL in a new tab. Otherwise, updates the 
 * history with the relative path and scrolls to the top of the page.
 */

const pushHistory = (history: any, e: any, newWindow?: boolean) => {

	if (!e?.ctrlKey && e?.preventDefault) e.preventDefault();
	else if (e?.ctrlKey) return;

	if (typeof e === "string") {
		if (newWindow) return window.open(e, "_blank", "noopener,noreferrer");
		return history.push(e);
	}
	// get the href and host url
	const fullUrl = e.target.href || e.currentTarget.href;

	// navigate
	if (newWindow) {
		window.open(fullUrl, "_blank", "noopener,noreferrer");
		return;
	} 
	// construct href
	const origin = e.target.origin || e.currentTarget.origin;
	const href = fullUrl?.replace(origin, "");
	history.push(href);
	// scroll
	window.scrollTo(0, 0);
};

export default pushHistory;
